import { render, staticRenderFns } from "./DashboardLinksItem.vue?vue&type=template&id=52b1561c&"
import script from "./DashboardLinksItem.vue?vue&type=script&lang=js&"
export * from "./DashboardLinksItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports